import React from 'react';
import { registerWidget } from '@okapi/core';
import { getGlobalRouter } from '@okapi/router-react';
import { State } from 'store/types';
import { CabinetRemote } from '../../common/widgets';
import { initWidgetData } from '../init-widget-data';

registerWidget<State, Record<string, string>>(`${__NAME__}/cabinet`, state => {
  const router = getGlobalRouter();
  const store = initWidgetData(state);

  return remoteProps => <CabinetRemote router={router} store={store} {...remoteProps} />;
});

